import React, { Component , useState , useRef } from 'react';
import { Table, message, Row, Tag } from 'antd';
import {Link} from 'react-router-dom'
import axios from 'axios'
import keys from '../../../../keys';

function SoldTag({is_sold , order_id}){

    const [tagText , setText] = useState(is_sold? "Sold":"Unsold")
    const [hover , setHover] = useState(false)
  

    function handleMouseEnter () {
        setHover(true)
        setText("View Invoice")
      
        
    }

    function handleMouseLeave(){
        setHover(false)
        setText("Sold")
    }

 


    return is_sold ? <Link to={`sales/order/${order_id}/`}> <Tag 
                style={(hover) ? {cursor:"pointer"}:{}}
                onMouseEnter={handleMouseEnter} 
                onMouseLeave = {handleMouseLeave}
                color={ hover ? "#87d068":"green"}

            >{tagText}</Tag> </Link>: 
            <Tag 
                style={(hover && is_sold) ? {cursor:"pointer"}:{}}
                onMouseEnter={handleMouseEnter} 
                onMouseLeave = {handleMouseLeave}
                color={"red"}

            >Unsold</Tag>
}




class ProductPieceList extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            data : [],
            loading : false,
            pagination:{
                total:0,
                pageSize:7,
                current:1
            }
         }
    }

    fetchData = (params) => {
        this.setState({
            loading:true
        })
        axios.get(`${keys.server}/warehouse/productpieces`,{params:params})
        .then(
            response => {
                const data = response.data.results
                const pagination = this.state.pagination
                pagination.total = response.data.count
                this.setState({
                    data:data,
                    pagination: pagination,
                    loading:false
                }, () => console.log(this.state.data))
            }
        )
        .catch(
            err => {
                console.error(err)
                message.error(err.message)
                this.setState({
                    loading:false
                })
            }
        )
    }
    

    componentDidMount(){
        this.fetchData({limit:this.state.pagination.pageSize , batch:this.props.batch})
    }
        
    
    onTableChange = pagination => {
        const {current , pageSize} = pagination
        this.setState({
            pagination: pagination
        },
        ()=>this.fetchData({offset:(current-1)*pageSize ,limit:pageSize,batch:this.props.batch}))
        
    }


    render() { 
        const columns = [
            {key:"item_code",dataIndex:"item_code",title:"Item Code" , width:"120px"},
            {key:"cost_price",dataIndex:"cost_price",title:"Cost Price" , width:"120px"},
            {key:"sell_price",dataIndex:"sell_price",title:"Sell Price" , width:"120px"},
            {key:"is_sold",dataIndex:"is_sold",title:"status" ,width:"120px", render : (is_sold,row)=><SoldTag is_sold={is_sold} order_id={row.order_id}></SoldTag>},
            {key:"current_place",dataIndex:"current_place",title:"Current Place",render : (current_place,row)=> row.is_sold ? "":<Tag color="blue">{current_place}</Tag>}
        ]
        return ( 
         <Row>   
            <Table 
                scroll={{y:300}} 
                columns={columns} 
                onChange={this.onTableChange} 
                pagination={this.state.pagination} 
                dataSource={this.state.data} 
                size="small" 
            />
        </Row>
        );
    }
}
 
export default ProductPieceList;